export default {
   // API_ENDPOINT: 'http://localhost:8000'
    API_ENDPOINT: 'https://shielded-temple-40772.herokuapp.com'
}